export default "__VITE_ASSET__7YyVxidS__"